import { useCallback, useEffect, useState } from 'react';
import { detectBlockchainInput, searchExplorer } from '../api/explorer';

export default function useExplorerSearch(query) {
  const [detection, setDetection] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const runSearch = useCallback(async (searchQuery) => {
    const trimmed = String(searchQuery || '').trim();
    if (!trimmed) {
      setError('Enter a transaction hash, block number, or wallet address.');
      setResult(null);
      setDetection(null);
      return;
    }

    const localDetection = detectBlockchainInput(trimmed);
    setDetection(localDetection);

    if (!localDetection) {
      setError('Could not detect blockchain network from this input.');
      setResult(null);
      return;
    }

    setLoading(true);
    setError('');
    setResult(null);

    try {
      const data = await searchExplorer(trimmed);
      setDetection(data.detection || localDetection);
      setResult(data);
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || 'Search failed. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (query) {
      runSearch(query);
    }
  }, [query, runSearch]);

  return { detection, result, loading, error, runSearch };
}
